import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

/* ====== Supporting Types ====== */

export interface Department {
  _id: string;
  name: string;
}

export interface Program {
  _id: string;
  name: string;
}

export interface HierarchicalTeamMember {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  role: string;
  position?: string;
  status: "Active" | "Inactive";
  employmentType?: string;
  department?: Department;
  program?: Program;
  profileImage?: string;
  startDate?: string;
}

/* ====== API Response ====== */

export interface HierarchicalTeamResponse {
  success: boolean;
  data: HierarchicalTeamMember[];
}

const fetchHierarchicalTeamMembers = async (): Promise<HierarchicalTeamResponse> => {
  const { data } = await customAxios.get<HierarchicalTeamResponse>(
    "/users/hierarchical-team"
  );
  return data;
};

export const useGetHierarchicalTeamMembers = () =>
  useQuery<HierarchicalTeamResponse, AxiosError>(
    ["hierarchicalTeamMembers"],
    fetchHierarchicalTeamMembers,
    {
      onError: (error) =>
        showNotification({
          title: "Error Loading Team Members",
          message:
            (error.response?.data as { message?: string })?.message ??
            "Failed to load team members",
          color: "red",
        }),
      staleTime: 0,
      retry: 1,
      refetchOnMount: "always",
    }
  );
